import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Loading } from "@/components/States";
import { api, formatError } from "@/lib/api";

const EMPTY = { title: "", subject_id: "", description: "", duration: "", mode: "", enquiry_url: "", active: true };

function CourseEditor({ course, onSaved }) {
  const [f, setF] = useState(course || EMPTY);
  const tid = course?.id || "new";
  const body = () => { const { id, order, ...rest } = f; return rest; };
  const save = async () => {
    try {
      if (course) await api.put(`/admin/courses/${course.id}`, body()); else { await api.post("/admin/courses", body()); setF(EMPTY); }
      toast.success("Course saved"); onSaved();
    } catch (e) { toast.error(formatError(e)); }
  };
  const remove = async () => {
    try { await api.delete(`/admin/courses/${course.id}`); toast.success("Course deleted"); onSaved(); } catch (e) { toast.error(formatError(e)); }
  };
  return (
    <div data-testid={`admin-course-${tid}`} className="rounded-xl border border-line bg-surface p-5">
      <div className="grid gap-3 sm:grid-cols-2">
        <Input data-testid={`course-title-${tid}`} placeholder="Course title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} />
        <Input data-testid={`course-url-${tid}`} placeholder="Enquiry link (https://...)" value={f.enquiry_url} onChange={(e) => setF({ ...f, enquiry_url: e.target.value })} />
        <Input placeholder="Duration" value={f.duration} onChange={(e) => setF({ ...f, duration: e.target.value })} />
        <Input placeholder="Mode (Online / Classroom)" value={f.mode} onChange={(e) => setF({ ...f, mode: e.target.value })} />
      </div>
      <Textarea className="mt-3" placeholder="Description" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} />
      <div className="mt-3 flex items-center gap-3">
        <label className="flex items-center gap-2 text-sm"><Switch checked={f.active} onCheckedChange={(v) => setF({ ...f, active: v })} />Visible on landing page</label>
        <Button size="sm" className="ml-auto" data-testid={`course-save-${tid}`} onClick={save}>{course ? "Save" : "Add course"}</Button>
        {course && <Button size="icon" variant="ghost" data-testid={`course-delete-${tid}`} onClick={remove}><Trash2 className="h-4 w-4" /></Button>}
      </div>
    </div>
  );
}

export default function AdminCourses() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/courses").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  if (!items) return <Loading />;
  return (
    <div className="flex flex-col gap-4">
      {items.map((c) => <CourseEditor key={c.id} course={c} onSaved={load} />)}
      <h3 className="mt-4 font-bold text-ink">Add a course</h3>
      <CourseEditor onSaved={load} />
    </div>
  );
}
